<template>
    <div>
      <div v-if="!verifyType">
        <p style="font-size: 25px; color: rgba(0, 0, 0, 0.85); font-weight: 800; margin-bottom: 20px;margin-top: 15px;">{{language['system.chooseLoginVerifyType']}}</p>
        <p @click="phoneVerify" v-if="!!this.phone">
          <img alt="example" style="width: 12%" src="@/assets/login-mail-verify.svg"/>
          <span style="font-size: 20px;font-weight: 500;padding-left: 20px;">{{language['system.loginPhoneVerify']}}</span>
        </p>
        <p @click="mailVerify" v-if="!!this.email">
          <img alt="example" style="width: 12%" src="@/assets/login-phone-verify.svg"/>
          <span style="font-size: 20px;font-weight: 500;padding-left: 20px;">{{language['system.loginEmailVerify']}}</span>
        </p>
        <p v-if="!this.email&&!this.phone">{{language['system.loginVerify.notPhoneAndMail']}}</p>
      </div>
      <verify-phone ref="verifyPhone"   @validateFail="validateFail" @fail="requestFailed"  @success="requestSuccess" v-show="verifyType=='phone'"/>
      <verify-mail ref="verifyMail"   @validateFail="validateFail" @fail="requestFailed"  @success="requestSuccess" v-show="verifyType=='mail'"/>
    </div>
</template>

<script>
  import VerifyPhone from './VerifyPhone'
  import VerifyMail from './VerifyMail'
    export default {
      components: {
        VerifyPhone,
        VerifyMail
      },
      name: "Verify",
      props: {

      },
      data() {
        return {
          username:'',
          password:'',
          checkKey:'',
          phone: '',
          email:'',
          verifyType:'',
        }
      },
      computed: {
        language() {
          return this.$store.getters.language
        },
      },
      methods:{
        phoneVerify(){
          this.verifyType = 'phone'
          this.$emit('verifyTypeChange','phone')
          this.$refs.verifyPhone.model.username=this.username
          this.$refs.verifyPhone.model.password=this.password
          this.$refs.verifyPhone.model.checkKey=this.checkKey
          this.$refs.verifyPhone.model.phone=this.phone
          this.$refs.verifyPhone.model.title = this.language['system.loginPhoneVerify.title'].replace("${phone}", this.phone.slice((this.phone.length-4), this.phone.length));
          // this.$refs.verifyMail.model.title="我们已向您的手机号 ******"+this.phone.slice((this.phone.length-4), this.phone.length)+" 发送验证码，请输入验证码进行登录"
        },
        mailVerify(){
          this.verifyType = 'mail'
          this.$emit('verifyTypeChange','mail')
          this.$refs.verifyMail.model.username=this.username
          this.$refs.verifyMail.model.password=this.password
          this.$refs.verifyMail.model.checkKey=this.checkKey
          this.$refs.verifyMail.model.email=this.email
          this.$refs.verifyMail.model.title=this.language['system.loginEmailVerify.title'].replace("${email}", this.email);
          // this.$refs.verifyMail.model.title="我们已向您的邮箱 "+this.email+" 发送验证码，请输入验证码进行登录"
        },
        initVerify(){
          this.verifyType = ''
          this.$emit('verifyTypeChange','');
        },
        validateFail(){
          this.$emit('validateFail')
        },
        requestFailed(err){
          // this.initVerify()
          this.$emit('fail',err)
        },
        requestSuccess(){
          this.$emit('success')
        },
        handleLogin(verifyType,rememberMe){
          if(verifyType=='phone'){
            this.$refs.verifyPhone.handleLogin(rememberMe)
          }else{
            this.$refs.verifyMail.handleLogin(rememberMe)
          }
        },
      }
    }
</script>

<style scoped>

</style>